module.exports = __webpack_public_path__ + "assets/img/img96.a7fa86db.png";